<template>
  <div class="toolsPanel">
    <div class="toolsPanel__control">
      <div>
        <a href="#" @click.prevent="close">
          <icon name="remove" />
        </a>
      </div>
    </div>
    <div
      v-if="toolsPanel_visibleItem && toolsPanel_openedItemsDescription[toolsPanel_visibleItem]"
      class="toolsPanel__content"
    >
      <AddWidget v-if="toolsPanel_visibleItem === 'addWidget'" />
      <EditWidget v-if="toolsPanel_visibleItem === 'editWidget'" />
      <CustomCode v-if="toolsPanel_visibleItem === 'editCustomCode'" />
      <Computed v-if="toolsPanel_visibleItem === 'editComputed'" />
      <Settings v-if="toolsPanel_visibleItem === 'editSettings'" />
      <Workflow v-if="toolsPanel_visibleItem === 'editWorkflow'" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// items
import AddWidget from './content/AddWidget'
import EditWidget from './content/EditWidget'
import CustomCode from './content/CustomCode'
import Computed from './content/Computed'
import Settings from './content/Settings'
import Workflow from './content/Workflow'

export default {
  components: {
    AddWidget,
    EditWidget,
    CustomCode,
    Computed,
    Settings,
    Workflow,
  },
  computed: {
    ...mapState([
      'toolsPanel_visibleItem',
      'toolsPanel_openedItemsDescription'
    ])
  },
  methods: {
    close () {
      this.$store.commit('toolsPanel_toggle', false)
      this.$store.commit('toolsPanel_release')
      localStorage.removeItem('frontwise');
    }
  }
}
</script>

<style lang="scss">
.toolsPanel {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  &__control {
    display: flex;
    justify-content: flex-end;
    border-bottom: 1px solid #ccc;
    padding: 0 4px 2px 4px;
  }
  &__content {
    flex-grow: 1;
    padding: {
      left: 3px;
      right: 10px;
      top: 5px;
      bottom: 5px;
    }
  }
}
</style>
